const load = <T>(elementId: string): Promise<T> => {
    const element = document.getElementById(elementId);
    return new Promise<T>((resolve, reject) => {
        const pluginSettings = element && element.getAttribute('data-plugin-settings');

        try {
            const parsedSettings = JSON.parse(pluginSettings || '');
            resolve(parsedSettings);
        } catch (error) {
            reject(new Error(`Could not load pluginSettings.\n${error}`));
        }
    });
};

const syncLoad = <T>(elementId: string): T => {
    const element = document.getElementById(elementId);
    const pluginSettings = element && element.getAttribute('data-plugin-settings');

    try {
        return JSON.parse(pluginSettings || '');
    } catch (error) {
        throw new Error(`Could not load pluginSettings.\n${error}`);
    }
};

export const pluginSettingsService = {
    load,
    syncLoad,
};
